@if (showSplash) {
  <div
    class="app-splash-screen"
  [ngStyle]="{
    left: windowWidth,
    opacity: opacityChange,
    transition: splashTransition
    }"
    >
    <div class="app-splash-inner">
      <div class="app-logo"></div>
      <div class="app-label">My Premises</div>
      <div class="app-loader"></div>
    </div>
  </div>
}
